/* eslint-disable react/jsx-filename-extension */
import {
  ChatBotOutlinedV2 as ChatBotOutlined,
  Google,
  Messenger,
  Instagram,
  InstagramSolid,
} from '@groovehq/internal-design-system/lib/assets/icons'
import thumbsUpImg from '@groovehq/internal-design-system/lib/assets/images/thumbs-up.png'
import gmailImg from '@groovehq/internal-design-system/lib/assets/images/auth-gmail.png'
import {
  DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
  DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS,
  DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH_MODAL,
  DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
  DRAWER_TYPE_CHANNELS_AUTHENTICATE,
  DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
  DRAWER_TYPE_CHANNELS_ADD_LIVE_CHAT,
} from 'ducks/drawers/types'
import {
  DRAWER_ID_FOLDERS_SELECT_EMAIL,
  DRAWER_ID_FOLDERS_CHANNEL_DETAILS,
  DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
  DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
  DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
  DRAWER_ID_FOLDERS_CHANNELS_ADD_LIVE_CHAT,
} from 'ducks/drawers/ids'
import { doSelectChatChannel } from 'ducks/channels/actions'
import {
  emailClosed as EmailClosed,
  emailV2 as EmailV2,
  chatsV2 as LiveChat,
} from 'assets/icons/groove/v2'

// Drawer ids are generated using

export const CHANNEL_MAIN_TYPES = {
  email: {
    drawer: {
      id: DRAWER_ID_FOLDERS_SELECT_EMAIL,
      type: DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
      closeIgnoresStack: true,
    },
    name: 'Email',
    icon: <EmailV2 />,
    title: `Email`,
    description:
      'Connect your Gmail account or forward from any other email address.',
  },
  chat: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_ADD_LIVE_CHAT,
      type: DRAWER_TYPE_CHANNELS_ADD_LIVE_CHAT,
      closeIgnoresStack: true,
    },
    doBeforeDrawer: doSelectChatChannel,
    name: 'Live Chat',
    icon: <LiveChat />,
    title: 'Live Chat',
    description:
      'Interact in real-time with customers on any page of your website or app.',
  },
  facebook: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Messenger',
    icon: <Messenger />,
    title: 'Messenger',
    description:
      'Connect your Facebook Page to handle incoming Messenger chats.',
    brandColor: '#0084ff',
  },
  instagram: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Instagram',
    icon: <Instagram />,
    solidIcon: <InstagramSolid />,
    title: 'Instagram',
    description:
      'Connect your Instagram account to handle incoming direct messages.',
    brandColor: '#0495f6',
  },
}

export const CHANNEL_EMAIL_TYPES = {
  google: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH_MODAL,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Gmail',
    icon: <Google />,
    headerImg: gmailImg,
    title: 'Connect Gmail',
    editTitle: 'Link your Gmail account',
    description:
      'Start recieving your GSuite or Gmail email directly in Groove',
    steps: 3,
  },
  // Disabled until we have time to propertly integrate outlook
  // using oauth integrations
  // outlook: {
  //   drawer: {
  //     id: null,
  //     type: DRAWER_TYPE_SAMPLE,
  //   },
  //   name: 'Outlook',
  //   icon: <Outlook />,
  //   headerImg: thumbsUpImg,
  //   title: 'Link up your Outlook account',
  // },
  forwarding: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
      type: DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
      closeIgnoresStack: true,
    },
    name: 'Other email',
    icon: <EmailClosed />,
    headerImg: thumbsUpImg,
    title: 'Other email client',
    editTitle: 'Forward your emails to Groove',
    description:
      'Setup email forwarding to receive your email in your Groove inbox',
    steps: 4,
  },
}

export const CHANNEL_ADDITIONAL_TYPES = {
  contact_widget: {
    doBeforeDrawer: doSelectChatChannel,
    name: 'Contact widget',
    icon: <ChatBotOutlined />,
    title: 'Contact widget',
    description: 'Set up a contact widget for your website or app.',
  },
}

export const CHANNEL_TYPES = {
  ...CHANNEL_MAIN_TYPES,
  ...CHANNEL_EMAIL_TYPES,
}

export const drawerConfig = {
  DEFAULT_DRAWER_TITLE: `New ${app.t('mailbox')}`,
}
